// Hash state for the submissions browser: `#submissions?status=replied,no_fish&feedback=with&sender=+1555…&species=Salmo%20trutta&channel=sms&start=2026-09-01&end=2026-09-30&id=<uuid>`
// Filters live in the URL so a view is shareable, like captureUrl.ts does.

export type FeedbackFilter = 'any' | 'with' | 'without'

export interface SubmissionsHashState {
  statuses: string[]
  feedback: FeedbackFilter
  sender: string | null
  species: string | null
  channel: string | null
  start: string | null // YYYY-MM-DD
  end: string | null
  id: string | null // open this submission's detail
}

export const EMPTY_SUBMISSIONS_STATE: SubmissionsHashState = {
  statuses: [],
  feedback: 'any',
  sender: null,
  species: null,
  channel: null,
  start: null,
  end: null,
  id: null,
}

export function parseSubmissionsHash(hash: string): SubmissionsHashState {
  const q = hash.includes('?') ? new URLSearchParams(hash.slice(hash.indexOf('?') + 1)) : new URLSearchParams()
  const fb = q.get('feedback')
  return {
    statuses: (q.get('status') ?? '').split(',').filter(Boolean),
    feedback: fb === 'with' || fb === 'without' ? fb : 'any',
    sender: q.get('sender'),
    species: q.get('species'),
    channel: q.get('channel'),
    start: q.get('start'),
    end: q.get('end'),
    id: q.get('id'),
  }
}

export function buildSubmissionsHash(s: SubmissionsHashState): string {
  const q = new URLSearchParams()
  if (s.statuses.length) q.set('status', s.statuses.join(','))
  if (s.feedback !== 'any') q.set('feedback', s.feedback)
  if (s.sender) q.set('sender', s.sender)
  if (s.species) q.set('species', s.species)
  if (s.channel) q.set('channel', s.channel)
  if (s.start) q.set('start', s.start)
  if (s.end) q.set('end', s.end)
  if (s.id) q.set('id', s.id)
  const qs = q.toString()
  return qs ? `#submissions?${qs}` : '#submissions'
}
